import script from "./MenuPicts.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuPicts.vue?vue&type=script&setup=true&lang=js"

import "./MenuPicts.vue?vue&type=style&index=0&id=4b26f64e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b26f64e"]])

export default __exports__